import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import { setUser, captureException } from '@sentry/vue';
import auth from './modules/auth'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    animal: "cat", //ﾆｬｰﾝ
    admins: {}, //管理者
    members: null, //全メンバー情報
    mine: {}, //自分の情報
    namelist: {}, //uid-name変換
    isAdmin: false, //管理者かどうか
    config: {}, //config
    lid: null, //Lid情報
    folder: [], //フォルダ情報
    navlid: null, //フォルダ付きlid情報
    alid: null, //非公開Lid情報
    aboutLid: {}, //Lid情報
    basetitle: "", //ベースタイトル
    lidusers: [], //Lidメンバー
    aboutpj: {}, //Project情報
    pjusers: [], //Projectメンバー
    pjadmins: [], //Project管理者
    notifys: [], //通知リスト
    notify_nums: 0, //通知数
    notifys_sum: [], //最新通知30件分
    notifys_pri: [], //Pri通知リスト
    notifys_pri_sum: [], //最新Pri通知30件分
    setting: {
      idea_loadLimit: false, //アイデアの読み込み制限
    }, //機能設定
    //getwcimg: {},  //竹原さんワードクラウドの取得いったん停止
    //Lid管理者はlid.lidAdminに所在
    logoSrc: '/defaultLogo.png',
    memLoaded: false,
    lidLoaded: false,
    importantAnnounceModalOpened: false,
  },
  mutations: {
    setting (state, el) {
      console.log(el)
      state.setting[el.key] = el.value
    },
    setAdmins (state, el) {
      state.admins = el
    },
    setBaseAdmins(state, el){
      state.admins.gov = el
    },
    setisAdmin (state, el) {
      //console.log("isAdmin",state.auth.user.uid)
      const test = false
      const uid = state.auth.user.uid
      if((uid&&(state.admins.gov.some( el => el === uid)||state.admins.liq.some( el => el === uid)))||test){
        //console.log("isAdmin",true)
        state.isAdmin = true

        // 管理者のみ、Sentryに情報を送信する
        try {
          setUser({
            id: uid,
            email: state.auth.user.email,
            username: state.auth.user.displayName,
          });
        } catch (error) {
          captureException(error);
        }
      }
    },
    setmembers (state, el) {
      state.members = el
    },
    setmine (state, el) {
      state.mine = el
    },
    setnamelist (state, el) {
      state.namelist = el
    },
    setconfig (state, el) {
      state.config = el
    },
    setConfigLocation (state, el) {
      state.config.location = el
    },
    setConfigTitle (state, el) {
      state.config.title = el
    },
    setConfigInq (state, el) {
      state.config.inquiry = el.inquiry
      state.config.inquiryUrl = el.inquiryUrl
    },
    setlid (state, el) {
      state.lid = el
    },
    setfolder (state, el) {
      state.folder = el
    },
    setnavlid (state, el) {
      state.navlid = el
    },
    setalid (state, el) {
      state.alid = el
    },
    setaboutLid (state, el) {
      state.aboutLid = el
    },
    setbasetitle (state, el) {
      state.basetitle = el
    },
    setlidusers (state, el) {
      state.lidusers = el
    },
    setlidadmins (state, el) {
      state.lid[el.index].lidAdmin = el.lidAdmin
      //console.log(state.lid[el.index])
    },
    setlidsanka (state, el) {
      let index = -1
      state.aboutLid.sanka = el.is
      if(state.lid.findIndex((u) => u.id === el.lidId) !== -1){
        index = state.lid.findIndex((u) => u.id === el.lidId)
        state.lid[index].sanka = el.is
      }
      else if(state.alid.findIndex((u) => u.id === el.lidId) !== -1){
        index = state.alid.findIndex((u) => u.id === el.lidId)
        state.alid[index].sanka = el.is
      }
      else if(state.navlid.findIndex((u) => u.id === el.lidId) !== -1){
        index = state.navlid.findIndex((u) => u.id === el.lidId)
        state.navlid[index].sanka = el.is
      }
    },
    setIsNotiIdeaFalse (state, el) {
      //console.log("setIsNotiIdeaFalse",el.at,el.index)
      if(el.at==="lid"){
        state.lid[el.index].isNotiIdea = false
      }
      else if(el.at==="alid"){
        state.alid[el.index].isNotiIdea = false
      }
      else if(el.at==="navlid"){
        state.navlid[el.index].isNotiIdea = false
      }
    },
    setPjAbout (state, el) {
      state.aboutpj = el
    },
    setPjAdmins (state, el) {
      state.pjadmins = el
    },
    setPjUsers (state, el) {
      state.pjusers = el
    },
    setHomeTime2 (state, el) {
      if(el.type==="zentei"){
        state.config.home_preinfoTime = el.date
      }
      else if(el.type==="news"){
        state.config.home_newsTime = el.date
      }
    },
    setLidTime2 (state, el) {
      let index = state.lid.findIndex((onelid)=> onelid.id == el.lidId)
      state.lid[index].updatedAt_preinfo = el.date
    },
    addLidMem1 ( state, index ) {
      state.lid[index].counter.member = state.lid[index].counter.member + 1
    },
    deLidMem1 ( state, index ) {
      state.lid[index].counter.member = state.lid[index].counter.member - 1
    },
    setLidDays ( state, {index, daynum} ) {
      state.lid[index].counter.days["daynum"] = daynum
      //console.log("days試験",daynum,state.lid[index].counter.days,state.lid[index].counter.days.daynum)
    },
    setLogoSrc (state, el) {
      state.logoSrc = el
    },
    setNotify (state, el) {
      state.notifys = el
      state.notifys_sum = el.slice(0,30)
    },
    setNotifyPri (state, el) {
      state.notifys_pri = el
      state.notifys_pri_sum = el.slice(0,30)
    },
    setNotify_num (state, el) {
      state.notify_nums = el
    },
    //竹原さんワードクラウドの取得いったん停止
    /*
    setwcimg (state, el) {
      state.getwcimg = el
    },       g
    */
    setMemLoaded (state, el) {
      state.memLoaded = el
    },
    setLidLoaded (state, el) {
      state.lidLoaded = el
    },
    setImportantAnnounceModalOpened (state, opened) {
      state.importantAnnounceModalOpened = opened
    },
  },
  actions: {
    setIdeaRead(context,lidId){
      let is = false, index = -1, at = ""
      if(context.state.lid.findIndex((u) => u.id === lidId) !== -1){
        index = context.state.lid.findIndex((u) => u.id === lidId)
        at = "lid"
        if(context.state.lid[index].isNotiIdea) is = true
      }
      else if(context.state.alid.findIndex((u) => u.id === lidId) !== -1){
        index = context.state.alid.findIndex((u) => u.id === lidId)
        at = "alid"
        if(context.state.alid[index].isNotiIdea) is = true
      }
      else if(context.state.navlid.findIndex((u) => u.id === lidId) !== -1){
        index = context.state.navlid.findIndex((u) => u.id === lidId)
        at = "navlid"
        if(context.state.navlid[index].isNotiIdea) is = true
      }
      //console.log("setIdeaRead",context.state.auth.user.uid,at,index,is)
      const now_ms = getNowMs()
      if(is && context.state.auth.user.uid) {
        context.commit('setIsNotiIdeaFalse', {"at":at, "index":index})
        firebase.firestore().collection("0").doc(lidId).collection("liduser").doc(context.state.auth.user.uid).set({
          readSort_idea: now_ms,
          readAt_idea: firebase.firestore.FieldValue.serverTimestamp()
        },{merge:true}).then(function(docRef) {
          // 保存に成功した時
          //console.log("USERss Document written with ID: ", docRef.id)
          //console.log("Lid既読成功")
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("Lid既読失敗: ", error)
        })          
      }
      if(is && context.state.auth.user.uid&&context.state?.admins?.gov.includes(context.state.auth.user.uid)) {
        firebase.firestore().collection("0").doc(lidId).set({
          readSort: now_ms,
          readAt: firebase.firestore.FieldValue.serverTimestamp()
        },{merge:true}).then(function(docRef) {
          // 保存に成功した時
          //console.log("USERss Document written with ID: ", docRef.id)
          //console.log("アイデア管理者既読成功")
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("アイデア管理者既読失敗: ", error)
        })          
      }
      is = false
      at = ""
    },
    setNotifyRead(context){
      const now_ms = getNowMs()
      firebase.firestore().collection("0").doc("config").collection("members").doc(context.state.auth.user.uid).set({
        readAt_noti: firebase.firestore.Timestamp.now(),
        readSort_noti: now_ms
      },{merge:true}).then(function(docRef) {
        let mine = context.state.mine
        mine.readAt_noti = firebase.firestore.Timestamp.now()
        mine.readSort_noti = now_ms
        context.commit("setmine", mine)
        // 保存に成功した時
        console.log("通知取得完了",context.state.auth.user.uid)
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("通知取得失敗: ", error)
      })
    },
    getNotify(context){
      let notify = [], notify_private = [], notify_num = 0
      let mine = context.state.mine
      let i = 0
      firebase.firestore().collection("0").doc("config").collection("notification").orderBy("createdAt", "desc").get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let oneno = doc.data()
          oneno.isNew = false
          if(mine&&mine.readAt_noti&&mine.readAt_noti<oneno.createdAt){
            oneno.isNew = true
            i++
            //console.log("lidNotification",mine.readAt_noti<oneno.createdAt,notify_num)
          }
          notify.push(oneno)
        })
        notify_num = i
        i = 0
      })
      let j = 0
      firebase.firestore().collection("0").doc("config").collection("notification").doc("private").collection(context.state.auth.user.uid).orderBy("sort", "desc").get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // idも含めたい
          let oneno = { ...doc.data(), id: doc.id }
          //console.log("lidNotification",oneno)
          if(mine&&mine.readAt_noti&&mine.readAt_noti<oneno.createdAt){
            oneno.isNew = true
            j++
          }
          notify.push(oneno)
          notify_private.push(oneno)
        })
        notify.sort((a,b) => b.sort - a.sort)
        notify_num = notify_num+j
        j = 0
        // 重要な通知がある場合はモーダルを表示
        if (notify_private.filter((noti)=>noti.isImportant && !noti.read).length) {
          context.dispatch('setImportantAnnounceModal', true)
        }
      })
      context.commit('setNotify', notify)
      context.commit('setNotifyPri', notify_private)
      context.commit('setNotify_num', notify_num)
      context.dispatch('getLids')
    },
    getLids(context){
      let lidids = []
      let collection = firebase.firestore().collection("0").where("isActive","==",true)
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(`${doc.id} => ${doc.data()}`)
          if(doc.id!=="config") lidids.push(doc.id)
        })
        context.dispatch('checkLidSanka', lidids)
      })
    },
    checkLidSanka(context,lidids){
      lidids.forEach((lidid) => {
        let collection = firebase.firestore().collection("0").doc(lidid).collection("liduser").doc(context.state.auth.user.uid)
        collection.get().then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            if(doc.data().isActive){
              //sankaLid.push(el)
              context.dispatch('getPjs', lidid)
            } 
          }
        }).catch((error) => {
          console.log("Error getting document:", error);
        });
        
      })
    },
    getPjs(context,lidid){
      let pjids = []
      let collection = firebase.firestore().collection("0").doc(lidid).collection("project").where("isActive","==",true)
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(`${doc.id} => ${doc.data()}`)
          pjids.push(doc.id)
        })
        context.dispatch('checkNotiType', {lidid,pjids})
      })
    },
    checkNotiType(context,payload){
      let pjids = payload.pjids, lidid = payload.lidid
      firebase.firestore().collection("0").doc("config").get().then((doc) => {
        if (doc.exists) {
          console.log("Config data:", doc.data());
          console.log(doc.data().setting.project_sanka)
          // Projectの通知を(Project参加にかかわらず)Lid参加者へ通知する
          if(doc.data().setting.project_sanka) pjids.forEach((pjid) => {
            context.dispatch('getPjNoti', {lidid,pjid})
          })
          // Projectの通知を該当プロジェクトに参加している者のみへ通知する
          else context.dispatch('checkPjSanka', {lidid,pjids})
        }
      }).catch((error) => {
        console.log("Error getting document:", error);
      });
    },
    checkPjSanka(context,payload){
      let lidid = payload.lidid
      payload.pjids.forEach((pjid) => {
        firebase.firestore().collection("0").doc(lidid).collection("project").doc(pjid).collection("user").doc(context.state.auth.user.uid).get().then((doc) => {
          if (doc.exists) {
            console.log("checkPjSanka data:", doc.data());
            if(doc.data().isActive){
              //sankaPj.push(el)
              context.dispatch('getPjNoti', {lidid,pjid})
            } 
          }
        }).catch((error) => {
          console.log("Error getting checkPjSanka:", error);
        });
      })
    },
    getPjNoti(context,payload){
      let i = 0
      let mine = context.state.mine, notify = context.state.notifys, notify_num = context.state.notify_nums
      let collection = firebase.firestore().collection("0").doc(payload.lidid).collection("project").doc(payload.pjid).collection("notification")
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(`${doc.id} => ${doc.data()}`)
          let oneno = doc.data()
          oneno.isNew = false
          if(mine&&mine.readAt_noti&&mine.readAt_noti<oneno.createdAt){
            oneno.isNew = true
            i++
            //console.log("lidNotification",mine.readAt_noti<oneno.createdAt,notify_num)
          }
          notify.push(oneno)
        })
        notify.sort((a,b) => b.sort - a.sort)
        notify_num = notify_num + i
        context.commit('setNotify', notify)
        context.commit('setNotify_num', notify_num)
      })
    },

    setImportantAnnounceModal({ commit }, value) {
      commit('setImportantAnnounceModalOpened', value)
    },  
    getMem(context){
      let members = [],namelist = {}, admins = {}
      let date = new Date()
      //let yyyy = date.getFullYear()
      const now_ms = getNowMs(date)
      //全メンバー情報取得
      let collectionM = firebase.firestore().collection("0").doc("config").collection("members")
      const promiseM = collectionM.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if(doc.id!=="admin"){
            members.push(doc.data())
            namelist[doc.id] = doc.data().name            
          }
          if(doc.id===context.state.auth.user.uid){
            context.commit('setmine', doc.data())
            //if(!doc.data().lastlogin||(doc.data().lastlogin&&doc.data().lastlogin.toDate().getTime()<(new Date( yyyy, date.getMonth(), date.getDate())))){
              //console.log("ログイン",firebase.firestore.Timestamp.now(),firebase.firestore.Timestamp.now().toDate())
            //}
          }
        })
        context.commit('setmembers', members)
        context.commit('setnamelist', namelist)
      })
      //全管理者取得
      let refAdminLiq = firebase.firestore().collection("0").doc("config").collection("admins").doc("liq")
      const promiseAdminLiq = refAdminLiq.get().then((doc) => {
        if(doc.exists){
          admins.liq = doc.data().admins
        }
      })
      let refAdminGov = firebase.firestore().collection("0").doc("config").collection("admins").doc("gov")
      const promiseAdminGov = refAdminGov.get().then((doc) => {
        if(doc.exists){
          admins.gov = doc.data().admins
        }
      })
      const promiseA = Promise.all([promiseAdminLiq, promiseAdminGov]).then(() => {
        //console.log(admins)
        context.commit('setAdmins', admins)  
        context.commit('setisAdmin')
              //通知取得
        context.dispatch('getNotify')
      })
      Promise.all([promiseM, promiseA]).then(() => {
        context.commit('setMemLoaded', true)
      }).catch((error) => {
        console.log('error getMem',error)
        // TODO: エラーだけどやむを得ずLoadedにする
        context.commit('setMemLoaded', true)
      })    
    },
    getLid(context){
      let lid = [],alid = [],navlid=[],folder=[],rwcimg={},collection = firebase.firestore().collection("0").where("isActive","==",true).orderBy('sort','desc')
      //全Lid情報取得
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let onelid = doc.data()
          onelid.id = doc.id
          if(onelid.id==="config"){
            //console.log(onelid.title)
            if(onelid.setting){
              if(onelid.setting.idea_loadLimit) context.commit('setting', {key:"idea_loadLimit",value:onelid.setting.idea_loadLimit})
            }
            context.commit('setconfig', onelid)
            context.commit('setbasetitle', onelid.title)  
          }
          else if(onelid.isfolder===true){
            let childlids = []
            onelid.childrenid.forEach(lidid => {
              firebase.firestore().collection("0").doc(lidid).get().then((doc) => {
                let onechildlid = doc.data()
                onechildlid.id = lidid
                onechildlid.sanka = false
                firebase.firestore().collection("0").doc(lidid).collection("liduser").doc(context.state.auth.user.uid).get().then((doc) => {
                  if (doc.exists) {
                    if(doc.data().isActive){
                      onechildlid.sanka = true
                      onechildlid.isNotiIdea = false
                      onechildlid.readSort_idea = 0
                      //最新のアイデア投稿日時取得（アイデア未読通知用）
                      if(doc.data().readSort_idea) onechildlid.readSort_idea = doc.data().readSort_idea
                      if(onechildlid.counter.idea>0){
                        firebase.firestore().collection("0").doc(lidid).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).orderBy("createdAt", "desc").limit(1).get().then((doc) => {
                          if (doc.exists) {
                            onechildlid.writeSort_idea = doc.data().sort
                            if(onechildlid.readSort_idea<onechildlid.writeSort_idea) onechildlid.isNotiIdea = true
                          }
                      }).catch((error) => {
                          console.log("Error getting writeSort_idea:", error);
                      });
                      }
                      //console.log("onechildR<W",onechildlid.isNotiIdea,onechildlid.readSort_idea<onechildlid.writeSort_idea)
                    }
                  }
                }).catch((error) => {
                  console.error("Error getting liduser document(child):", error);
                });
                childlids.push(onechildlid)
              }).catch((error) => {
                console.log("Error getting liduser document:", error);
              });
            })  
            onelid.childlids = childlids
            if(onelid.isOpen==="public") navlid.push(onelid)
            //else if(context.state.isAdmin) alid.push(onelid)
          }
          else{
            onelid.sanka = false
            onelid.isNotiIdea = false
            onelid.readSort_idea = 0
            //if(!onelid.sankaNum) onelid.sankaNum = {isActive:true}
            //console.log(onelid.sankaNum)
            //そのLidに参加しているかどうか
            firebase.firestore().collection("0").doc(onelid.id).collection("liduser").doc(context.state.auth.user.uid).get().then((doc) => {
              if (doc.exists) {
                if(doc.data().isActive){
                  onelid.sanka = true
                }
                //最新のアイデア投稿日時取得（アイデア未読通知用）
                if(doc.data().readSort_idea) onelid.readSort_idea = doc.data().readSort_idea //自分の最新のアイデア読込日時
                //console.log("lidsanka:", onelid.id,onelid.readSort_idea,onelid?.counter?.idea,doc.data())
              } else {
                //console.log("lidNOsanka")
              }
            }).then(()=> {
              if(onelid?.counter?.idea>0){
                //console.log("ideanum",onelid.title,onelid?.counter?.idea)
                firebase.firestore().collection("0").doc(onelid.id).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).orderBy("sort", "desc").limit(1).get().then(snapshot => {
                  snapshot.forEach(doc => {
                    //console.log("Document data:",doc.data().sort, doc.exists);
                    onelid.writeSort_idea = doc.data().sort
                    if(onelid.readSort_idea<onelid.writeSort_idea) onelid.isNotiIdea = true
                    //console.log(onelid.title,"onelidR<W",onelid.isNotiIdea,onelid.readSort_idea<onelid.writeSort_idea)
                    
                  })
                })
              }
              //console.log(onelid.title,onelid.isOpen,context.state.isAdmin)
              if(onelid.ischild != true){
                if(onelid.isOpen==="public") navlid.push(onelid)
              }

              let mnum = onelid.counter.member
              if(onelid.counter.days){
                if(!onelid.counter.days.daynum) onelid.counter.days.daynum = [mnum,mnum,mnum,mnum,mnum,mnum]
              } 
              else{
                onelid.counter.days = {daynum:[mnum,mnum,mnum,mnum,mnum,mnum]}
              } 
              
              if(onelid.isOpen==="public") lid.push(onelid)
              else if(context.state.isAdmin || context.state.auth.user.isGovStaff || onelid.sanka) alid.push(onelid)
              // else console.log('非公開Lid',onelid.title)
            }).catch((error) => {
              console.log("Error getting lid user document:", error);
            });
          }
        })
        context.commit('setlid', lid)
        context.commit('setalid', alid)
        context.commit('setnavlid', navlid)
        //context.commit('setwcimg', wcimg) //竹原さんワードクラウドの取得いったん停止
      }).then(()=>{
        context.commit('setLidLoaded', true)
      }).catch((error) => {
        console.log('error getLid',error)
        // TODO: エラーだけどやむを得ずLoadedにする
        context.commit('setLidLoaded', true)
      })
    },
    getAboutLid(context,lidid){
      // これ参考にして作る
      // if(lid.some((u) => u.id === $route.params.id)) {
      //   aboutLid = lid.filter((u) => u.id === $route.params.id)[0]
      // } else if (alid.some((u) => u.id === $route.params.id)) {
      //   aboutLid = alid.filter((u) => u.id === $route.params.id)[0]
      // } else {
      //   console.error('lid not found')
      //   $router.push('/sp_home')
      // }
      if (context.state.lid.some((u) => u.id === lidid)) {
        context.commit('setaboutLid', context.state.lid.filter((u) => u.id === lidid)[0])
        return true
      } else if (context.state.alid.some((u) => u.id === lidid)) {
        context.commit('setaboutLid', context.state.alid.filter((u) => u.id === lidid)[0])
        return true
      } else {
        console.error('lid not found. lidid:',lidid)
        context.commit('setaboutLid', null)
        return false
      }
    },
    getCounter(context){
      /*
        counter: {
          yyyy(number): 2023 //年
          mm(number): 01 //月
          day(number): 20230107 //日数
          days(map/object){
            0101(map/object) //日付
            ...
            0107{
              in (array): [] //参加した人のuidの配列
              out(array): [] //退出した人のuidの配列
            }
          }
        }
      */
      //console.log("getCounter!!!!")
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = toDoubleDigits(date.getMonth() + 1)
      let dd = toDoubleDigits(date.getDate())
      let day7 = mm + "-" + dd
      date.setDate(date.getDate() - 1)
      let day6 = toDoubleDigits(date.getMonth() + 1) + "-" + toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      let day5 = toDoubleDigits(date.getMonth() + 1) + "-" + toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      let day4 = toDoubleDigits(date.getMonth() + 1) + "-" + toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      let day3 = toDoubleDigits(date.getMonth() + 1) + "-" + toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      let day2 = toDoubleDigits(date.getMonth() + 1) + "-" + toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      let lid = context.state.lid
      lid.forEach((oneLid,index)=>{
        //let lidid = oneLid.id
        //let lidTitle = oneLid.title
        let counter = oneLid.counter
        //console.log("getCounter",index,lidid,lidTitle,counter)
        if(counter){
          let daynum = [0,0,0,0,0,0] //１日目から６日目までの参加人数
          let days_ = {
            7: { in: 0, out: 0},
            6: { in: 0, out: 0},
            5: { in: 0, out: 0},
            4: { in: 0, out: 0},
            3: { in: 0, out: 0},
            2: { in: 0, out: 0},
          }
          if(counter.days){
            if(counter.yyyy&&counter.yyyy===yyyy) {
              if(counter.days[day7]){
                if(counter.days[day7].in&&counter.days[day7].in.length>0) days_[7].in = counter.days[day7].in.length
                if(counter.days[day7].out&&counter.days[day7].out.length>0) days_[7].out = counter.days[day7].out.length
              }
              if(counter.days[day6]){
                if(counter.days[day6].in&&counter.days[day6].in.length>0) days_[6].in = counter.days[day6].in.length
                if(counter.days[day6].out&&counter.days[day6].out.length>0) days_[6].out = counter.days[day6].out.length
              }
              if(counter.days[day5]){
                if(counter.days[day5].in&&counter.days[day5].in.length>0) days_[5].in = counter.days[day5].in.length
                if(counter.days[day5].out&&counter.days[day5].out.length>0) days_[5].out = counter.days[day5].out.length
              }
              if(counter.days[day4]){
                if(counter.days[day4].in&&counter.days[day4].in.length>0) days_[4].in = counter.days[day4].in.length
                if(counter.days[day4].out&&counter.days[day4].out.length>0) days_[4].out = counter.days[day4].out.length
              }
              if(counter.days[day3]){
                if(counter.days[day3].in&&counter.days[day3].in.length>0) days_[3].in = counter.days[day3].in.length
                if(counter.days[day3].out&&counter.days[day3].out.length>0) days_[3].out = counter.days[day3].out.length
              }
              if(counter.days[day2]){
                if(counter.days[day2].in&&counter.days[day2].in.length>0) days_[2].in = counter.days[day2].in.length
                if(counter.days[day2].out&&counter.days[day2].out.length>0) days_[2].out = counter.days[day2].out.length
              }
              //console.log(daynum,days_)
            }
          }
          daynum[5] = counter.member - days_[7].in + days_[7].out //６日目の参加人数
          daynum[4] = daynum[5] - days_[6].in + days_[6].out //５日目の参加人数
          daynum[3] = daynum[4] - days_[5].in + days_[5].out //４日目の参加人数
          daynum[2] = daynum[3] - days_[4].in + days_[4].out //３日目の参加人数
          daynum[1] = daynum[2] - days_[3].in + days_[3].out //２日目の参加人数
          daynum[0] = daynum[1] - days_[2].in + days_[2].out //１日目の参加人数
          //console.log("daynumm",daynum,days_)
          context.commit("setLidDays", {index, daynum})        
        }
        else console.log("収穫なし") 
      })
    },
    getLidMembers(context,lidid){
      //Lidメンバーをとってくる。メンバー表示などで使う。
      let lidusers = [], collection = firebase.firestore().collection("0").doc(lidid).collection("liduser")
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          lidusers.push(doc.data())
        })
        context.commit('setlidusers', lidusers)
      })
    },
    setLidAdmin(context,el){
      context.commit('setlidadmins', {index:el.index, lidAdmin:el.lidAdmin})
    },
    setBaseAdmin(context,el){
      context.commit('setBaseAdmins', el)
    },
    setPj(context,el){
      context.commit('setPjAbout', el.aboutpj)
      context.commit('setPjAdmins', el.pjadmins)
      context.commit('setPjUsers', el.pjusers)
    },
    setPjAdmin(context,el){
      context.commit('setPjAdmins', el)
    },
    setPjUser(context,el){
      context.commit('setPjUsers', el)
    },
    setHomeTime(context,el){
      console.log("setHomeTime",el)
      context.commit('setHomeTime2', el)
    },
    setLidTime(context,el){
      console.log("setLidTime",el)
      context.commit('setLidTime2', el)
    },
    getLogoSrc(context){
      let filepath = "logo/"+"logo.jpeg";
      const ref = firebase.storage().ref(filepath);
      try {
        ref.getDownloadURL().then((url)=>{
          context.commit('setLogoSrc', url)
        });
      } catch (error) {
        console.log("error: ",error)
      }
    },
    setConfigNotify(context,payload){
      let lidid = "", pjid = ""
      if(payload.lidid) lidid = payload.lidid
      if(payload.pjid) pjid = payload.pjid      
      const now_ms = getNowMs()
      //console.log("通知情報送信",now_ms,payload.title,payload.content)
      const targetAddress = payload.address
      const isImportant = payload.isImportant || false
      console.log(isImportant)
      if(targetAddress!=="all"){
          //特定の人向け
        if (!Array.isArray(targetAddress)) {
          firebase.firestore().collection("0").doc("config").collection("notification").doc("private").collection(targetAddress).doc(now_ms).set({
            sort: now_ms,
            author: context.state.auth.user.uid,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            content: payload.content,
            isPrivate: true,
            isImportant: isImportant,
            read: false,
            address: targetAddress,
            title: payload.title,
            type: payload.type,
            tag: payload.tag,
            lidid: lidid,
            pjid: pjid
          }).then(function(docRef) {
            if (payload?.usePush || payload?.useMail || payload?.useLine) {
              firebase.functions().httpsCallable('notify')({
                title: `${context.state.auth.user.displayName}が、${payload.title}を投稿しました`,
                text: payload.content,
                target: targetAddress,
                url: window.location.origin,
                usePush: payload?.usePush || false,
                useMail: payload?.useMail || false,
                useLine: payload?.useLine || false,
              })
            }
            //console.log("USERs Document written with ID: ", docRef.id)
            //console.log("Config通知登録完了")
          }).catch(function(error) {
            console.error("通知登録失敗: ", error)
            alert("Error!:"+error)
          })
        } else {
          targetAddress.forEach((address) => {
            firebase.firestore().collection("0").doc("config").collection("notification").doc("private").collection(address).doc(now_ms).set({
              sort: now_ms,
              author: context.state.auth.user.uid,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
              content: payload.content,
              isPrivate: true,
              isImportant: isImportant,
              read: false,
              address: targetAddress,
              title: payload.title,
              type: payload.type,
              tag: payload.tag,
              lidid: lidid,
              pjid: pjid
            })
          })
          if(payload.usePush || payload.useMail || payload.useLine){
            firebase.functions().httpsCallable('notify')({
              title: `${context.state.auth.user.displayName}が、${payload.title}を投稿しました`,
              text: payload.content,
              target: targetAddress,
              url: window.location.origin,
              usePush: payload?.usePush || false,
              useMail: payload?.useMail || false,
              useLine: payload?.useLine || false,
            })
          }
        }
      } else {
        //全員向け
        firebase.firestore().collection("0").doc("config").collection("notification").doc(now_ms).set({
          sort: now_ms,
          author: context.state.auth.user.uid,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          content: payload.content,
          isPrivate: false,
          address: targetAddress,
          title: payload.title,
          type: payload.type,
          tag: payload.tag,
          lidid: lidid,
          pjid: pjid
        }).then(function(docRef) {
          if (payload?.usePush || payload?.useMail || payload?.useLine) {
            firebase.functions().httpsCallable('notify')({
              title: `${context.state.auth.user.displayName}が、${payload.title}を投稿しました`,
              text: payload.content,
              target: targetAddress,
              url: window.location.origin,
              usePush: payload?.usePush || false,
              useMail: payload?.useMail || false,
              useLine: payload?.useLine || false,
            })
          }
          //console.log("USERs Document written with ID: ", docRef.id)
          //console.log("Config通知登録完了")
        }).catch(function(error) {
          console.error("通知登録失敗: ", error)
          alert("Error!:"+error)
        })          
      }

    },
    setLidNotify(context,payload){
      const now_ms = getNowMs()
      //console.log("通知情報送信",now_ms,payload.title,payload.content)
      let isPri = false
      const targetAddress = payload.address
      if(targetAddress!=="all") isPri = true

      firebase.firestore().collection("0").doc(payload.lidid).collection("notification").doc(now_ms).set({
        date: now_ms,
        author: context.state.auth.user.uid,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        content: payload.content,
        isPrivate: isPri,
        address: targetAddress,
        title: payload.title,
        type: payload.type,
        tag: payload.tag,
        lidid: payload.lidid
      }).then(function(docRef) {
        if (payload?.usePush || payload?.useMail || payload?.useLine) {
          firebase.functions().httpsCallable('notify')({
            title: `${context.state.auth.user.displayName}が、${payload.title}を投稿しました`,
            text: payload.content,
            target: targetAddress,
            url: window.location.origin,
            usePush: payload?.usePush || false,
            useMail: payload?.useMail || false,
            useLine: payload?.useLine || false,
          })
        }
        //console.log("USERs Document written with ID: ", docRef.id)
        //console.log("Lid通知登録完了")
      }).catch(function(error) {
        console.error("Lid通知登録失敗: ", error)
        alert("Error!:"+error)
      }) 
    },
    settingConfig(context,payload){
      if(payload.type=="map") context.commit('setConfigLocation', payload.el)
      else if(payload.type=="inq") context.commit('setConfigInq', payload.el)
      else if(payload.type=="title") context.commit('setConfigTitle', payload.el)
    },
    inLid(context,payload){
      const now_ms = getNowMs()
      firebase.firestore().collection("0").doc(payload.lidId).collection("liduser").doc(payload.uid).set({
        uid: payload.uid,
        invitee: payload.uid,
        isActive:true,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        readAt_idea: firebase.firestore.FieldValue.serverTimestamp(),
        readSort_idea: now_ms,
      },{merge:true}).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        context.commit("setlidsanka",{lidId: payload.lidId, is: true})
        console.log("Lid参加完了")
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Lid参加失敗: ", error)
      })
    },
    outLid(context,payload){
      firebase.firestore().collection("0").doc(payload.lidId).collection("liduser").doc(payload.uid).set({
        remover: payload.uid,
        isActive:false,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      },{merge:true}).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        context.commit("setlidsanka",{lidId: payload.lidId, is: false})
        console.log("Lid脱退完了")
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Lid脱退失敗: ", error)
      })
    }
  },
  modules: {
    auth,
  }
})

function toDoubleDigits(num) {
  num += "";
  if (num.length === 1) {
    num = "0" + num;
  }
  return num; 
}

function getNowMs(date=new Date()){
  let yyyy = date.getFullYear()
  let mm = date.getMonth() + 1
  mm += "";
  if (mm.length === 1) mm = "0" + mm
  let dd = date.getDate()
  dd += "";
  if (dd.length === 1) dd = "0" + dd
  let hh = date.getHours()
  hh += "";
  if (hh.length === 1) hh = "0" + hh
  let mi = date.getMinutes()
  mi += "";
  if (mi.length === 1) mi = "0" + mi
  let se = date.getSeconds()
  se += "";
  if (se.length === 1) se = "0" + se
  let ms = date.getMilliseconds()
  ms += "";
  if (ms.length === 1) ms = "0" + ms
  return yyyy + mm + dd + hh + mi + se + ms
}